import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {CarouselFooter} from "./carousel-footer";
import {WithDevice} from "../../composers/with-device";
import {CarouselArrowSmall} from "./carousel-arrow-small";
import {CarouselArrowLarge} from "./carousel-arrow-large";
import {DeviceViewModel} from "../../../models/device.view-model";
import {Swipeable, SwipeableProps} from "../../swipeable/swipeable";
import {CarouselContainer} from "./carousel-container";
import {CarouselSlot} from "./carousel-slot";
import {DIRECTIONS} from "../carousel.consts";
import {CarouselComposer} from "./carousel-composer";
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"

export class CarouselProps extends BaseProps {
  isSmallView: Boolean;
  sliding: Boolean;
  initialIndex: Number;
  position: Number;
  childrenCount: Number;
  direction: String;
  nextArrowLabel: String;
  previousArrowLabel: String;
  device: DeviceViewModel;
  onSlide: Function;
  onCalcOrder: Function;
  onChange: Function;
  hideFooter: Boolean;
  shouldRenderSmallArrow: Boolean;
  shouldCenterArrow: Boolean;
  arrowClassName: String;
  autoSwitchTimeMS: Number;
}

const Carousel = CarouselComposer(WithDevice((props: CarouselProps) => {
  const Arrow = props.isSmallView || props.shouldRenderSmallArrow ? CarouselArrowSmall : CarouselArrowLarge;

  const swipeableProps: SwipeableProps = {
    onSwipedLeft: () => props.onSlide(props.device.isRtl ? DIRECTIONS.previous : DIRECTIONS.next),
    onSwipedRight: () => props.onSlide(props.device.isRtl ? DIRECTIONS.next : DIRECTIONS.previous),
  }

  return (
    <Swipeable {...swipeableProps}>
      <div className={classNames(styles.container, {[styles.small_view]: props.isSmallView})}>
        <CarouselContainer
          direction={props.direction}
          sliding={props.sliding}
          isSmallView={props.isSmallView}
          isRtl={props.device.isRtl}
        >
          {
            React.Children.map(props.children, (child, index) => (
              <CarouselSlot
                key={index}
                order={props.onCalcOrder(index, props.position, props.childrenCount)}
              >
                {child}
              </CarouselSlot>
            ))
          }
        </CarouselContainer>
        <Arrow
          onClick={() => props.onSlide(DIRECTIONS.previous)}
          label={props.previousArrowLabel}
          isPrev shouldCenterArrow={props.shouldCenterArrow} className={props.arrowClassName}
        />
        {
          !props.hideFooter ? <CarouselFooter
            selectedDotIndex={props.position}
            count={props.childrenCount}
            onClick={(index) => props.onSlide(null, index)}
          /> : null
        }
        <Arrow
          onClick={() => props.onSlide(DIRECTIONS.next)}
          label={props.nextArrowLabel} shouldCenterArrow={props.shouldCenterArrow} className={props.arrowClassName}
        />
      </div>
    </Swipeable>
  )
}));

export default Carousel;
